// @ts-strict-ignore
import type { HTMLProps, ReactNode } from "react";

import { stripAttributesFromHTMLString } from "@shared/helpers/stripAttributesFromHTMLString";

import * as styles from "./HTML.styles";

interface HTMLComponentProps extends HTMLProps<HTMLDivElement> {
  /**
   * Optionally centers any content passed into the component
   *
   * @default false
   */
  isCentered?: boolean;
  /**
   * Optionally strip all markup tags from the content
   *
   * @default false
   */
  sanitizeHTML?: boolean;
  /**
   * Content, simple as that
   *
   * @default undefined
   */
  children?: ReactNode;
}

/**
 * Documentation:
 * https://aviary.docs.fullscript.cloud/components/display/HTML
 */
const HTML = ({
  isCentered,
  sanitizeHTML,
  dangerouslySetInnerHTML,
  children,
  ...rest
}: HTMLComponentProps) => {
  const contentStyles = [styles.content, isCentered && styles.centered];

  const getInnerHTML = () => {
    if (sanitizeHTML) {
      // eslint-disable-next-line no-underscore-dangle
      const htmlText = dangerouslySetInnerHTML?.__html;

      /* eslint-disable-next-line @typescript-eslint/naming-convention */
      return { __html: stripAttributesFromHTMLString(htmlText as string, ["class", "style"]) };
    }

    return dangerouslySetInnerHTML;
  };

  return (
    <div css={contentStyles} dangerouslySetInnerHTML={getInnerHTML()} {...rest}>
      {children}
    </div>
  );
};

HTML.displayName = "Aviary.HTML";

export { HTML };
